export default {
    isLoggedIn: state => !!state.token.length,
    authStatus: state => state.status,
    
}
